import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthServiceGuard } from '../services/auth/auth-service.guard';

import { HomePage } from './pages/home/home.page';
import { LoginPage } from './pages/login/login';
import { SettingsPage } from './pages/settings/settings';
import { PrivateComponent } from './private.component';

const routes: Routes = [{
  path: '',
  component: PrivateComponent,
  children: [
    { path: 'home', component: HomePage, canActivate: [AuthServiceGuard] },
    { path: 'login', component: LoginPage },
    { path: 'settings', component: SettingsPage },

    { path: 'actions', loadChildren: () => import('./pages/actions-module/actions-module.module').then(m => m.ActionsModulePageModule), canActivate: [AuthServiceGuard] },
    { path: 'catalog', loadChildren: () => import('./pages/catalog-module/catalog-module.module').then(m => m.CatalogModulePageModule), canActivate: [AuthServiceGuard] },
    { path: 'orders', loadChildren: () => import('./pages/handshipping-module/handshipping-module.module').then(m => m.HandShippingModulePageModule), canActivate: [AuthServiceGuard] },
    { path: 'billing', loadChildren: () => import('./pages/invoices-module/invoices-module.module').then(m => m.InvoicesModulePageModule), canActivate: [AuthServiceGuard] },

    { path: 'crm', loadChildren: () => import('./pages/crm-module/crm-module.module').then(m => m.CrmModulePageModule), canActivate: [AuthServiceGuard] },
    { path: 'cms', loadChildren: () => import('./pages/cms-module/cms-module.module').then(m => m.CmsModulePageModule), canActivate: [AuthServiceGuard]  },

    { path: 'about', loadChildren: './pages/common-module/pages/about/about.module#AboutPageModule' },

    { path: '', redirectTo: 'home', pathMatch: 'full' }
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrivateRoutingModule {
}
